// salesmanAction.js
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";
import {
  CREATE_SALESMAN_REQUEST,
  CREATE_SALESMAN_SUCCESS,
  CREATE_SALESMAN_FAIL,
  FETCH_SALESMAN_LIST_REQUEST,
  FETCH_SALESMAN_LIST_SUCCESS,
  FETCH_SALESMAN_LIST_FAIL,
  CREATE_SALESMAN_CUSTOMER_REQUEST,
  CREATE_SALESMAN_CUSTOMER_SUCCESS,
  CREATE_SALESMAN_CUSTOMER_FAIL,
  FETCH_SALESMAN_CUSTOMER_LIST_REQUEST,
  FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
  FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
  VALIDATE_QR_REQUEST,
  VALIDATE_QR_SUCCESS,
  VALIDATE_QR_FAIL,
  REDEEM_QR_REQUEST,
  REDEEM_QR_SUCCESS,
  REDEEM_QR_FAIL,
  FETCH_REDEMTION_CUSTOMER_REQUEST,
  FETCH_REDEMTION_CUSTOMER_SUCCESS,
  FETCH_REDEMTION_CUSTOMER_FAIL,
  GIFT_REDEEM_QR_REQUEST,
  GIFT_REDEEM_QR_SUCCESS,
  GIFT_REDEEM_QR_FAIL,
  FETCH_SALESMAN_DASHBOARD_DATA_REQUEST,
  FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS,
  FETCH_SALESMAN_DASHBOARD_DATA_FAIL,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS,
  FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL,
} from "../actionTypes";

export const createSalesman = (salesmanData, token) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_SALESMAN_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/add-salesman/",
        salesmanData, // This now includes all 8 fields
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CREATE_SALESMAN_SUCCESS,
        payload: response.data,
      });
      return { type: CREATE_SALESMAN_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: CREATE_SALESMAN_FAIL,
        payload: errorPayload,
      });
      return { type: CREATE_SALESMAN_FAIL, payload: errorPayload };
    }
  };
};
// export const fetchSalesmanList = (token) => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_SALESMAN_LIST_REQUEST });
//     try {
//          const params = {};
      
//       // Add download parameter if requested
//       if (options.download === true) {
//         params.download = true;
//       }
    
//          const response = await axiosInstance.get("/api/get-salesman", {
//         params: params,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       dispatch({
//         type: FETCH_SALESMAN_LIST_SUCCESS,
//         payload: response.data.data,
//       });
//     } catch (error) {
//       const errorPayload = error.response
//         ? error.response.data
//         : "Network Error";
//       dispatch({
//         type: FETCH_SALESMAN_LIST_FAIL,
//         payload: errorPayload,
//       });
//     }
//   };
// };

export const fetchSalesmanList = (token, options = {}) => {  
  return async (dispatch) => {
    dispatch({ type: FETCH_SALESMAN_LIST_REQUEST });
    try {
      const params = {};
      
      // Add download parameter if requested
      if (options.download === true) {
        params.download = true;
      }

      const response = await axiosInstance.get("/api/get-salesman/", {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: FETCH_SALESMAN_LIST_SUCCESS,
        payload: response.data.data,
      });

      return {
        type: FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_SALESMAN_LIST_FAIL,
        payload: errorPayload,
      });
      return {
        type: FETCH_SALESMAN_LIST_FAIL,
        payload: errorPayload,
      };
    }
  };
};
export const createSalesmanCustomer = (customerData, token) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_SALESMAN_CUSTOMER_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/create-customer/",
        customerData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: CREATE_SALESMAN_CUSTOMER_SUCCESS,
        payload: response.data,
      });
      return { type: CREATE_SALESMAN_CUSTOMER_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: CREATE_SALESMAN_CUSTOMER_FAIL,
        payload: errorPayload,
      });
      return { type: CREATE_SALESMAN_CUSTOMER_FAIL, payload: errorPayload };
    }
  };
};

// export const fetchSalesmanCustomerList = (token) => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_SALESMAN_CUSTOMER_LIST_REQUEST });
//     try {
//       // Add cache-busting parameter to prevent 304 responses
//       const timestamp = new Date().getTime();
//       const response = await axiosInstance.get("/api/get-customers/", {
//         // params: {
//         //   _t: timestamp, // Cache-busting parameter
//         // },
//         // headers: {
//         //   Authorization: `Bearer ${token}`,
//         //   'Cache-Control': 'no-cache',
//         //   'Pragma': 'no-cache',
//         // },

//  headers: {
//             Authorization: `Bearer ${token}`,
//           },
          
//       });
//       dispatch({
//         type: FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
//         payload: response.data.data,
//       });
//       return {
//         type: FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
//         payload: response.data,
//       };
//     } catch (error) {
//       const errorPayload = error.response
//         ? error.response.data
//         : "Network Error";
//       dispatch({
//         type: FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
//         payload: errorPayload,
//       });
//       return {
//         type: FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
//         payload: errorPayload,
//       };
//     }
//   };
// };


export const fetchSalesmanCustomerList = (token, options = {}) => {  
  return async (dispatch) => {
    dispatch({ type: FETCH_SALESMAN_CUSTOMER_LIST_REQUEST });
    try {
      const params = {};
      
      // Add download parameter if requested
      if (options.download === true) {
        params.download = true;
      }

       if (options.city) {                                // ← ADD
        params.city = options.city;                       // ← ADD
      }    

      

      const response = await axiosInstance.get("/api/get-customers/", {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
        payload: response.data.data,
      });

      return {
        type: FETCH_SALESMAN_CUSTOMER_LIST_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
        payload: errorPayload,
      });
      return {
        type: FETCH_SALESMAN_CUSTOMER_LIST_FAIL,
        payload: errorPayload,
      };
    }
  };
};
export const validateQRCode = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: VALIDATE_QR_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/validate-qr-code/",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VALIDATE_QR_SUCCESS,
        payload: response.data,
      });
      return { type: VALIDATE_QR_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response?.data || "Network Error";
      dispatch({
        type: VALIDATE_QR_FAIL,
        payload: errorPayload,
      });
      return { type: VALIDATE_QR_FAIL, payload: errorPayload };
    }
  };
};

// Redeem multiple QR codes
export const ValidateandAcumlateQRCodes = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: REDEEM_QR_REQUEST });
    try {
      const response = await axiosInstance.post("/api/redeem-codes/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: REDEEM_QR_SUCCESS,
        payload: response.data,
      });
      return { type: REDEEM_QR_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response?.data || "Network Error";
      dispatch({
        type: REDEEM_QR_FAIL,
        payload: errorPayload,
      });
      return { type: REDEEM_QR_FAIL, payload: errorPayload };
    }
  };
};
export const fetchRedemptionCustomers = (token) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_REDEMTION_CUSTOMER_REQUEST });
    try {
      const response = await axiosInstance.get("/api/get-redeemed-gifts/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_REDEMTION_CUSTOMER_SUCCESS,
        payload: {
          data: response.data?.data || [],
          total_qr_codes_used: response.data?.total_qr_codes_used ?? 0,
        },
      });
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: FETCH_REDEMTION_CUSTOMER_FAIL,
        payload: errorPayload,
      });
    }
  };
};
export const giftRedeemQRCode = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: GIFT_REDEEM_QR_REQUEST });
    try {
      const response = await axiosInstance.post(
        "/api/redeem-gift-with-qr/",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: GIFT_REDEEM_QR_SUCCESS,
        payload: response.data,
      });
      return { type: GIFT_REDEEM_QR_SUCCESS, payload: response.data };
    } catch (error) {
      const errorPayload = error.response
        ? error.response.data
        : "Network Error";
      dispatch({
        type: GIFT_REDEEM_QR_FAIL,
        payload: errorPayload,
      });
      return { type: GIFT_REDEEM_QR_FAIL, payload: errorPayload };
    }
  };
};

// Update customer details (mirrors backend /api/update-customer/)
export const updateCustomer = (data, token) => {
  return async (dispatch) => {
    // No dedicated action types; reuse customer list fetch after update
    try {
      const response = await axiosInstance.post("/api/update-customer/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
     toast.success(response.data.message || "Customer updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      
      // Dispatch action to update Redux store if needed
      dispatch({ type: "CUSTOMER_UPDATED", payload: response.data.data });
      
      return { success: true, data: response.data };
    } catch (error) {
      const errorPayload = error.response?.data || { message: "Network Error" };
       toast.error(errorPayload.message || "Failed to update customer", {
        position: "top-right",
        autoClose: 3000,
      });
      
      return { success: false, error: errorPayload };
    }
  };
};

export const fetchSalesmanDashboardData = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SALESMAN_DASHBOARD_DATA_REQUEST });
    try {
      const response = await axiosInstance.post("/api/salesman-report/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS,
        payload: response.data,
      });
      return {
        type: FETCH_SALESMAN_DASHBOARD_DATA_SUCCESS,
        payload: response.data,
      };
    } catch (error) {
      const errorPayload = error.response?.data || "Network Error";
      dispatch({
        type: FETCH_SALESMAN_DASHBOARD_DATA_FAIL,
        payload: errorPayload,
      });
      return {
        type: FETCH_SALESMAN_DASHBOARD_DATA_FAIL,
        payload: errorPayload,
      };
    }
  };
};

export const fetchSalesmanConsolidatedReport = (data, token) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SALESMAN_CONSOLIDATED_REPORT_REQUEST });
    try {
      const response = await axiosInstance.post("/api/salesman-report/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      dispatch({
        type: FETCH_SALESMAN_CONSOLIDATED_REPORT_SUCCESS,
        payload: response.data,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const errorPayload = error.response?.data || { message: "Network Error" };
      dispatch({
        type: FETCH_SALESMAN_CONSOLIDATED_REPORT_FAIL,
        payload: errorPayload,
      });
      return {
        success: false,
        error: errorPayload,
      };
    }
  };
};
